import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPassword.vue')
  },
  {
    path: '/dashboard',
    component: () => import('@/views/common/Dashboard.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DashboardHome',
        component: () => import('@/views/common/home/DashboardHome.vue')
      },
      {
        path: 'campus',
        name: 'Campus',
        component: () => import('@/views/common/home/Campus.vue')
      },
      {
        path: 'course-schedule',
        name: 'CourseSchedule',
        component: () => import('@/views/common/schedule/CourseSchedule.vue'),
        meta: { userType: 'student' }
      },
      {
        path: 'skill-tree',
        name: 'SkillTree',
        component: () => import('@/views/common/skills/SkillTree.vue')
      },
      {
        path: 'students',
        name: 'StudentsManagement',
        component: () => import('@/views/common/management/StudentsManagement.vue',)
      },
      {
        path: 'teachers',
        name: 'TeachersManagement',
        component: () => import('@/views/common/management/TeachersManagement.vue')
      },
      {
        path: 'forum',
        name: 'Forum',
        component: () => import('@/views/common/home/forum.vue')
      },
    ]
  },
  {
    path: '/teacher/dashboard',
    component: () => import('@/views/common/teacher/T-Dashboard.vue'),
    meta: { requiresAuth: true, userType: 'teacher' },
    children: [
      {
        path: '',
        name: 'TeacherDashboardHome',
        component: () => import('@/views/common/teacher/home/T-DashboardHome.vue')
      },
      {
        path: 'students',
        name: 'TeacherStudentsManagement',
        component: () => import('@/views/common/management/StudentsManagement.vue')
      },
      {
        path: 'teachers',
        name: 'TeacherTeachersManagement',
        component: () => import('@/views/common/management/TeachersManagement.vue')
      },
      {
        path: 'recruitment',
        name: 'TeacherRecruitment',
        component: () => import('@/views/common/teacher/recruitment/T-RecruitmentList.vue')
      },
      {
        path: 'applications',
        name: 'TeacherApplications',
        component: () => import('@/views/common/teacher/recruitment/T-Applications.vue')
      }

    ]
  },
  {
    path: '/admin',
    component: () => import('@/views/admin/AdminDashboard.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: '',
        name: 'AdminHome',
        component: () => import('@/views/admin/home/AdminHome.vue')
      },
      {
        path: 'notices/list',
        name: 'NoticeList',
        component: () => import('@/views/admin/notices/NoticeList.vue')
      },
      {
        path: 'notices/new',
        name: 'NoticeNew',
        component: () => import('@/views/admin/notices/NoticeNew.vue')
      },
      {
        path: 'notices/edit/:id',
        name: 'NoticeEdit',
        component: () => import('@/views/admin/notices/NoticeEdit.vue')
      },
      {
        path: 'notices/club-announcements',
        name: 'ClubAnnouncements',
        component: () => import('@/views/admin/notices/ClubAnnouncements.vue')
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/views/admin/users/Users.vue')
      },
      {
        path: 'users/:id',
        name: 'UserView',
        component: () => import('@/views/admin/users/UserView.vue')
      },
      {
        path: 'users/:id/edit',
        name: 'UserEdit',
        component: () => import('@/views/admin/users/UserEdit.vue')
      }
    ]
  },
  {
    path: '/information-editing',
    name: 'InformationEditing',
    component: () => import('@/views/common/information/InformationEditing.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/information-editing-second',
    name: 'InformationEditingSecond',
    component: () => import('@/views/common/information/InformationEditingSecond.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/clubs/:id',
    name: 'ClubDetail',
    component: () => import('@/views/clubs/ClubDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard/profile',
    name: 'PersonalProfile',
    component: () => import('@/views/PersonalProfile.vue')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const isAdmin = userInfo.userType === 'admin';
  const isTeacher = userInfo.userType === 'teacher';

  if (to.path === '/login' || to.path === '/register') {
    next();
    return;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!userInfo.token) {
      next('/login');
      return;
    }
  }

  if (userInfo.token && !userInfo.hasCompletedProfile &&
    !to.path.startsWith('/information-editing') &&
    to.path !== '/login' &&
    !isAdmin && !isTeacher) {
    next('/information-editing');
    return;
  }

  if (userInfo.hasCompletedProfile &&
    (to.path.includes('/information-editing') || to.path.includes('/information-editing-second'))) {
    next('/dashboard');
    return;
  }

  next();
});

export default router;